<template>
  <div>
    <iframe
      :src="url"
      frameborder="0"
      id="myiframe"
      width="100%"
      allowtransparency
      v-resize="{ log: true }"
    ></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url:
        process.env.VUE_APP_REPORTING_URL + "public/dashboard/c9770975-229e-4d1e-a353-b25a6aefbdb3"
    };
  },
  created() {
  },
};
</script>
